import { getEnvOrDefault } from './runtime-env';

/**
 * API config.
 *
 * @property {string} url='' - API base url.
 */
const apiConfig = {
  get url() {
    return getEnvOrDefault('NEXT_PUBLIC_API_URL', '');
  },
  get happyReturnsId() {
    return getEnvOrDefault('NEXT_PUBLIC_HAPPY_RETURNS_ID', '1');
  },
};

export default apiConfig;
